import React from "react";
import Icon, { IconTypes } from "shared/ui/icon";
import Modal, { ModalType } from "shared/ui/modal";
import CustomLink from "shared/ui/typography/CustomLink";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";

interface MonthlyPaymentModalProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
}

interface MonthlyPaymentModalListItem {
  id: string;
  icon: IconTypes;
  description: JSX.Element | string;
}

const SPRAYPAY_INFO_LIST: MonthlyPaymentModalListItem[] = [
  {
    id: "spraypay-terms",
    icon: IconTypes.CHECK,
    description:
      "SprayPay biedt de mogelijkheid om jouw aankoop in 12, 18, 24, 36 of 60 maanden te betalen.",
  },
  {
    id: "spraypay-amount",
    icon: IconTypes.CHECK,
    description: "Mogelijk bij een aankoopbedrag van € 250,- tot € 10.000,-",
  },
  {
    id: "spraypay-early-repayment",
    icon: IconTypes.CHECK,
    description: "Wil je eerder of extra aflossen? Dit kan altijd boetevrij.",
  },
  {
    id: "spraypay-monthly",
    icon: IconTypes.CHECK,
    description:
      "Je hebt een vast maandbedrag. Het eerste termijn wordt afgeschreven 30 dagen na goedkeuring van SprayPay.",
  },
  {
    id: "spraypay-calculate",
    icon: IconTypes.CHECK,
    description: (
      <>
        Bereken{" "}
        <CustomLink
          to="https://gewoongers.nl/gespreid-betalen-bij-gewoongers/"
          bold={false}
          opacityTransition={false}
          className="gg-underline"
        >
          hier
        </CustomLink>{" "}
        je maximale aankoopbedrag, je maandbedrag of lees meer over gespreid
        betalen met SprayPay
      </>
    ),
  },
];

const MonthlyPaymentModal = ({
  isOpen,
  setIsOpen,
}: MonthlyPaymentModalProps) => {
  return (
    <Modal
      type={ModalType.SQUARE}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      className="gg-max-w-xl gg-p-5"
    >
      <div>
        <Heading headingLevel="h4" className="gg-mb-2">
          SprayPay
        </Heading>

        <ul className="gg-grid gg-gap-y-3" role="list">
          {SPRAYPAY_INFO_LIST.map(({ id, icon, description }) => (
            <li className="gg-flex gg-items-center gg-gap-x-3" key={id}>
              <Icon
                name={icon}
                alt=""
                className="gg-inline-block gg-h-4 gg-w-4 gg-shrink-0 gg-object-contain"
              />
              <Text className="gg-w-full gg-text-sm">{description}</Text>
            </li>
          ))}
        </ul>

        <Text className="gg-mt-10 gg-text-sm gg-font-bold">
          Let op: Geld lenen kost geld!
        </Text>
      </div>
    </Modal>
  );
};
export default MonthlyPaymentModal;
